import { bindable, inject } from 'aurelia-framework';
import { boundMethod } from 'autobind-decorator';
import flatpickr from 'flatpickr';

@inject(Element)
class OdsCalendar {
  @bindable placeholder = 'Select date';
  @bindable options = {};
  @bindable onDateChange = () => {};
  @bindable onInstanceReady = () => {};
  constructor(element) {
    this._element = element;
    this._input = null;
    this._instance = null;
  }
  attached() {
    this._input = this._element.querySelector('input');
    this._instance = flatpickr(this._input, Object.assign({}, this.options, {
      onChange: this._onFlatpickrChange,
      onReady: this._onFlatpickrInstanceReady,
    }));
  }
  detached() {
    this._instance.destroy();
  }
  @boundMethod
  _onFlatpickrChange(selectedDates, dateStr, instance) {
    this.onDateChange({
      selectedDates,
      dateStr,
      instance,
      input: this._input,
    });
  }
  @boundMethod
  _onFlatpickrInstanceReady(selectedDates, dateStr, instance) {
    this.onInstanceReady({
      selectedDates,
      dateStr,
      instance,
      input: this._input,
    });
  }
}

export { OdsCalendar };
